import React from 'react';
import { FaPaperclip } from 'react-icons/fa';
import './NoticeItem.css';

const NoticeItem = ({ notice }) => {
  const { category, title, date, url, views, hasAttachment } = notice;

  // Helper to get category class
  const getCategoryClass = (cat) => {
    if (!cat) return '';
    switch (cat) {
      case '학사': return 'cat-academic';
      case '입학': return 'cat-admission';
      case '취업': return 'cat-employment';
      case '채용/모집': return 'cat-recruitment';
      case '장학': return 'cat-scholarship';
      case '행사/세미나': return 'cat-event';
      case '일반': return 'cat-general';
      case '수강증원': return 'cat-course';
      default: return 'cat-default';
    }
  };

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="notice-item">
      <div className="notice-header">
        {category && (
          <span className={`notice-category ${getCategoryClass(category)}`}>
            {category}
          </span>
        )}
        <span className="notice-date">{date}</span>
      </div>
      <div className="notice-title">
        {title}
      </div>
      <div className="notice-footer">
        {hasAttachment && <FaPaperclip className="attachment-icon" />}
        <span className="notice-views">조회수 {views}</span>
      </div>
    </a>
  );
};

export default NoticeItem;